import { Box, IconButton } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import makeStyles from '@mui/styles/makeStyles';
import SearchIcon from '@mui/icons-material/Search';
import { useRef, useState } from 'react';
import { useSelector } from 'react-redux';
import { StatusNotesBubbleForm } from './StatusNotesBubbleForm';
import { StatusNotesBubbleFormV2 } from './StatusNotesBubbleFormV2';
import MenuPopover from '../../../MenuPopover';
import { Z_INDEX } from '../../../../constants/zIndex';

const useStyles = makeStyles((theme) => ({
  common: {
    backgroundColor: '#FFF',
    boxShadow: theme.shadows[10],
    transition: 'all 0.2s ease',
    zIndex: Z_INDEX.HEADER_DROPDOWN,
    overflow: 'hidden',
    width: '30px',
    height: '30px',
    borderRadius: '50%',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  closed: {
    width: '30px',
    height: '30px',
    borderRadius: '50%',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  opened: {
    width: '660px',
    borderRadius: '1rem',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'flex-start',
    alignItems: 'flex-start',
    transition: 'all 0.2s ease',
  },
  background: {
    width: '100vw',
    height: '100vh',
    position: 'fixed',
    top: 0,
    left: 0,
    zIndex: Z_INDEX.HEADER_DROPDOWN - 1,
    transition: 'all 0.2s ease',
    backgroundColor: 'transparent',
  },
}));

export const StatusNotesBubble = ({ bigIcon, isOpen, onToggle, onClose }) => {
  const theme = useTheme();
  const classes = useStyles(theme);
  const [open, setOpen] = useState(false);
  const iconButton = useRef(null);
  const useNewHouseholdSearch = useSelector(
    (state) => state.featureFlags.flags?.ENABLE_NEW_HOUSEHOLD_SEARCH
  );

  const handleIconClick = () => {
    // Use external state management if provided, otherwise use internal state
    if (onToggle) {
      onToggle();
    } else {
      if (open) {
        setOpen(false);
      } else {
        setOpen(true);
      }
    }
  };

  const handleClose = () => {
    if (onClose) {
      onClose();
    } else {
      setOpen(false);
    }
  };

  // Determine if popover should be open
  const isPopoverOpen = onToggle ? isOpen : open;

  return (
    <>
      <Box
        className={classes.common}
        style={{
          width: bigIcon ? 40 : 30,
          height: bigIcon ? 40 : 30,
        }}
      >
        <IconButton ref={iconButton} onClick={handleIconClick} size="large">
          <SearchIcon fontSize="small" />
        </IconButton>
      </Box>

      <MenuPopover
        open={isPopoverOpen}
        onClose={handleClose}
        anchorEl={iconButton?.current}
        sx={{ width: 660 }}
        container={document.body}
        slotProps={{
          paper: {
            sx: {
              zIndex: Z_INDEX.HEADER_DROPDOWN,
            },
          },
        }}
      >
        {useNewHouseholdSearch ? (
          <StatusNotesBubbleFormV2 onClose={handleClose} />
        ) : (
          <StatusNotesBubbleForm onClose={handleClose} />
        )}
      </MenuPopover>
    </>
  );
};
